import {CutsiteFilter} from 'molbio/tabstates/MiniMapTabState';

export function shouldShowHiddenAnnotationsWarning({
  shownAnnotationsCount,
  visibleAnnotationsCount,
}: {
  shownAnnotationsCount?: number;
  visibleAnnotationsCount?: number;
}): boolean {
  return shownAnnotationsCount !== visibleAnnotationsCount;
}

export function shouldShowHiddenCutsitesWarning({
  cutsiteFilter,
}: {
  cutsiteFilter: CutsiteFilter | null;
}): boolean {
  return (
    cutsiteFilter != null &&
    (cutsiteFilter.before !== cutsiteFilter.after || cutsiteFilter.blackList.length > 0)
  );
}
